import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { GlobalTheme } from '~/_base/apeMuiTheme';
import InlineHelp from '~/_base/components/inlineHelp';

/**
 * A custom hook for injecting <InlineHelp /> into a rails view
 * Searches for any divs with classname 'ape-inline-help-injection'
 * and renders <InlineHelp /> along with the necessary style
 */
export default function UseInlineHelp() {
  useEffect(() => {
    function injectIfFound() {
      const helpElements = document.getElementsByClassName(
        'ape-inline-help-injection'
      );

      if (!helpElements) return;

      var style = document.createElement('style');
      style.innerHTML = `
      .ape-inline-help-injection {
        display: inline-block;
      }`;
      document.head.appendChild(style);

      if (helpElements) {
        const elementsArray = Array.from(helpElements);
        elementsArray.forEach(element => {
          const helpkey = element.getAttribute('data-helpkey');
          createRoot(element).render(
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={GlobalTheme}>
                <InlineHelp helpkey={helpkey || ''} />
              </ThemeProvider>
            </StyledEngineProvider>
          );
        });
      }
    }

    injectIfFound();
  }, []);
}
